module.exports = __webpack_public_path__ + "images/icons_v2/settings-outlined-8b054640.svg";